import React from "react";
import "../../assets/css/about.css";
import AboutImage from "../../assets/img/src/shingan_mok01.png";

const AboutArea = (props) => {
  return (
    <section className="about-container" id={props.id}>
      <div className="about-container--inner yu-gothic center-box center">
        <div className="about-headline">
          <span className="about-strong">芸術作品</span>と
          <span className="about-strong">世界に１つだけのデータ</span>を
          <div className="about-headline">紐付けて管理する</div>
          <div className="spacer-box--m" />
          <div className="grid__row--center">
            <div className="about-img-box">
              <img className="" src={AboutImage} alt="about画像" />
            </div>

            <div className="center">
              <div className="left about-text">・作品を独自の技術で登録</div>
              <div className="spacer-box--s" />
              <div className="left about-text">
                ・世界に１つだけのデータを生成
              </div>
              <div className="spacer-box--m" />
              <div className="patent-mark center-box">特許出願中</div>
              <div className="spacer-box--sss" />
              <div className="patent-number">特許出願番号 2021-71310</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutArea;
